import { Component } from '@angular/core';
import { STATIC_DATA } from '../../../shared/constants/static-data.constants';
import { ParticipantLeadsListComponent } from '../../participant-leads-list/participant-leads-list.component';
import { PAGE_CONSTANTS } from '../../../shared/constants/page.constants';
import { Router } from '@angular/router';
import { SectionsService } from '../../../services/sections.service';
import { ReferralDataService } from '../../../services/referral-data.service';
import { SharedDataService } from '../../../shared/services/shared-data-service';
import { AuthorizationUtility } from '../../../shared/authorization/auth.utility';
import { AllowListAuthStore } from '../../../shared/authorization/allow-list-auth.store';
import { LeadDetailsService } from '../../../services/lead-details.service';
import {  ListTableComponent  } from '@ppl/ui';
import { UserService } from '../../../services/user.service';
import { StorageService } from '../../../services/storage.service';
import { NotificationService } from '../../../shared/services/notification.service';

@Component({
  selector: 'ppl-global-search',
  standalone: true,
  imports: [ListTableComponent],
  templateUrl: './global-search.component.html',
  styleUrl: './global-search.component.css',
})
export class GlobalSearchComponent extends ParticipantLeadsListComponent {
  override sharedDataKey: string =
    STATIC_DATA.SHARED_GLOBAL_CONSUMER_SEARCH_DATA;
  override pageId: string = PAGE_CONSTANTS.GLOBAL_PARTICIPANT_DATA_GRID_PAGE;

  constructor(
    router: Router,
    sectionService: SectionsService,
    referralDataService: ReferralDataService,
    sharedDataService: SharedDataService,
    authUtility: AuthorizationUtility,
    private leadDetailsService: LeadDetailsService,
    userService: UserService,
    private storageService: StorageService,
    allowListStore: AllowListAuthStore,
    private notificationService: NotificationService
  ) {
    super(
      router,
      sectionService,
      referralDataService,
      sharedDataService,
      userService,
      authUtility,
      allowListStore
    );
  }

  /* override onNewLead(): void {
    this.router.navigate(['/referralLogic']);
    this.sectionService.setFlow('providers');
    this.referralDataService.clearReferrralData();
  }

  onNewReferral() {
    this.router.navigate(['/newReferral']);
    this.sectionService.setFlow('providerEnrollment');
    this.userService.setLeadEntry('');
    this.referralDataService.clearReferrralData();
  }

  onNewEnrollment() {
    this.router.navigate(['/newReferral']);
    this.storageService.setParticipantId("");
    this.sectionService.setFlow('participantEnrollment');
    this.userService.setLeadEntry('');
    this.referralDataService.clearReferrralData();
  } */

  override rowClicked(rowDetail: any) {
    const program = this.userService.getSelectedProgram();

    this.userService.setSelectedLead(rowDetail.id);

    if (rowDetail.type.toLocaleLowerCase() === 'participant') {
       this.userService.setFirstSegment('participantEnrollmentList');
      this.userService.setLeadEntry('participantEnrollment');
      this.referralDataService.clearReferrralData();

      if (
        rowDetail.applicationStatus?.toLocaleLowerCase() == 'new application' ||
        rowDetail.applicationStatus?.toLocaleLowerCase() == 'in progress'
      ) {
        if (this.isReadOnly) {
          this.notificationService.error('View Only', 'Cannot open in-progress applications in view-only mode.');
          return;
        }
        this.leadDetailsService
          .fetchLeadDetailsApi(
            'participantEnrollment',
            program ? program.program_code : '',
            rowDetail.id
          )
          .subscribe((data: any) => {
            this.referralDataService.setReferralDetails(data.responsedata);

            this.sectionService.setFlow('participantEnrollment');
            this.storageService.setParticipantId(data?.responsedata?.infoData.participantId
            );
            this.storageService.setParticipantPPLId(data.responsedata?.infoData.participantPPLId
            );
            this.storageService.setTrackingNumber(data.responsedata?.infoData.trackingNumber
            );

            setTimeout(() => {
              this.router.navigate(['/newReferral']);
            }, 200);
          });
      } else {
        this.referralDataService.clearReferrralData();
        this.userService.setFirstSegment('globalConsumerSearch');
        this.redirectToDetailPage();
      }
    } else {
       this.userService.setFirstSegment('globalConsumerSearch');

      this.referralDataService.clearReferrralData();

      this.userService.setLeadEntry('referral');
      this.sectionService.setFlow('referral');

      if (
        rowDetail.applicationStatus == '' ||
        rowDetail.applicationStatus == null
      ) {
        if (this.isReadOnly) {
          this.notificationService.error('View Only', 'Cannot open in-progress applications in view-only mode.');
          return;
        }
        this.leadDetailsService
          .fetchLeadDetailsApi('referral', program ? program.program_code : '', rowDetail.id)
          .subscribe((data: any) => {
            this.referralDataService.setReferralDetails(data.responsedata);
            setTimeout(() => {
              this.storageService.setReferralId(
                data.responsedata?.infoData?.referralId
              );
              this.router.navigate(['/newReferral']);
            }, 200);
          });
      } else {
        setTimeout(() => {
          this.redirectToDetailPage();
        }, 200);
      }
    }
  }

  redirectToDetailPage(): void {
    setTimeout(() => {
      this.router.navigate(['/home/globalConsumerSearch/details/']);
    }, 200);
  }
}
